import React from 'react';

import { Icon, useTranslation } from '@testsigma/atoms';

const SelectConnectionFormHeader: React.FC = () => {
  const { t } = useTranslation();
  return (
    <header className='flex items-center justify-between h-15'>
      <div className='flex items-center'>
        <div className='ml-8 mr-2 items-center my-4 font-medium text-lg text-secondary-unique-600'>
          {t('select.metadata.connection')}
        </div>
      </div>
    </header>
  );
};

export { SelectConnectionFormHeader };
